import ArchitecturalDesign from '../assets/images/services/architectural-design.jpg'
import Arch1 from '../assets/images/services/architectural-design.jpg'
import Arch2 from '../assets/images/services/architectural-design.jpg'
import Arch3 from '../assets/images/services/architectural-design.jpg'

import Construction from '../assets/images/services/Constuction.jpg'
import Const1 from '../assets/images/services/Constuction.jpg'
import Const2 from '../assets/images/services/Constuction.jpg'
import Const3 from '../assets/images/services/Constuction.jpg'

import InteriorDesign from '../assets/images/services/interior-design.jpg'
import Int1 from '../assets/images/services/interior/interior-design.jpg'
import Int2 from '../assets/images/services/interior/interior-design1.jpg'
import Int3 from '../assets/images/services/interior/interior-design10.jpg'
import Int4 from '../assets/images/services/interior/interior-design12.jpg'
import Int5 from '../assets/images/services/interior/interior-design13.jpg'
import Int6 from '../assets/images/services/interior/interior-design6.jpg'
import Int7 from '../assets/images/services/interior/interior-design8.jpg'

import RealEstate from '../assets/images/services/Real-estates.jpg'
import RE1 from '../assets/images/services/Real-estates.jpg'
import RE2 from '../assets/images/services/Real-estates.jpg'

import LandSurvey from '../assets/images/services/surveying.jpg'
import LS1 from '../assets/images/services/surveying.jpg'
import LS2 from '../assets/images/services/surveying.jpg'

export const services = [
  {
    slug: 'architectural-design',
    title: 'Architectural Design',
    shortDescription:
      'Innovative architectural solutions that balance aesthetics, function, sustainability, and regulatory compliance.',
    image: ArchitecturalDesign,
    gallery: [Arch1, Arch2, Arch3],

    description:
      `We provide comprehensive architectural design services for residential, commercial, and institutional projects.
      Our approach integrates creativity, sustainability, and technical precision to deliver spaces that are functional,
      visually compelling, and aligned with the client’s vision and budget. We guide projects from concept to approval
      and execution support.`,

    features: [
      'Concept & schematic design',
      'Residential projects',
      'Commercial & mixed-use projects',
      '3D visualization & presentation',
      'Construction & permit drawings',
      'Sustainable and climate-responsive design',
    ],

    process: [
      {
        title: 'Client Brief',
        description: 'Understanding client goals, site conditions, budget, and regulatory context.',
      },
      {
        title: 'Concept Development',
        description: 'Initial layouts, massing, and design concepts.',
      },
      {
        title: 'Detailed Design',
        description: 'Technical drawings, specifications, and approvals.',
      },
      {
        title: 'Construction Support',
        description: 'Design coordination during execution.',
      },
    ],
  },

  {
    slug: 'construction',
    title: 'Construction',
    shortDescription:
      'Reliable, high-quality construction services delivered with safety, efficiency, and durability.',
    image: Construction,
    gallery: [Const1, Const2, Const3],

    description:
      `We offer full-cycle construction services from foundation to final finishes. Our team ensures quality
      workmanship, strict safety standards, cost control, and timely delivery. We manage residential, commercial,
      and institutional construction projects of varying scale and complexity.`,

    features: [
      'Turnkey construction solutions',
      'Residential & commercial buildings',
      'Site supervision & quality control',
      'Structural and finishing works',
      'Renovation & extensions',
    ],

    process: [
      {
        title: 'Planning',
        description: 'Construction planning, scheduling, and budgeting.',
      },
      {
        title: 'Execution',
        description: 'On-site construction with skilled teams and supervision.',
      },
      {
        title: 'Quality Control',
        description: 'Continuous inspections and compliance checks.',
      },
      {
        title: 'Handover',
        description: 'Final inspection, documentation, and delivery.',
      },
    ],
  },

  {
    slug: 'interior-design',
    title: 'Interior Design',
    shortDescription:
      'We craft interior spaces that are functional, aesthetic, and aligned with the identity of each client.',
    image: InteriorDesign,
    gallery: [Int1, Int2, Int3, Int4, Int5, Int6, Int7],

    description:
      `Our interior design services transform spaces into comfortable, efficient, and visually appealing environments.
      We carefully select materials, finishes, lighting, and furniture to reflect the client’s personality and brand
      while optimizing usability and comfort.`,

    features: [
      'Residential & commercial interiors',
      'Space planning & layouts',
      'Material & finish selection',
      'Lighting & furniture design',
      'Interior fit-out supervision',
    ],

    process: [
      {
        title: 'Design Brief',
        description: 'Understanding lifestyle, function, and aesthetic preferences.',
      },
      {
        title: 'Concept Design',
        description: 'Mood boards, layouts, and style development.',
      },
      {
        title: 'Detailing',
        description: 'Finishes, furniture, and lighting specifications.',
      },
      {
        title: 'Implementation',
        description: 'Site coordination and installation support.',
      },
    ],
  },

  {
    slug: 'real-estate',
    title: 'Real Estate',
    shortDescription:
      'Professional guidance in property investment, development, and acquisition.',
    image: RealEstate,
    gallery: [RE1, RE2],

    description:
      `We support clients throughout the real estate value chain—from feasibility studies and property acquisition
      to development advisory and investment guidance. Our expertise ensures informed decisions and sustainable returns.`,

    features: [
      'Property acquisition advisory',
      'Real estate feasibility studies',
      'Development consultancy',
      'Investment guidance',
      'Market analysis',
    ],

    process: [
      {
        title: 'Market Analysis',
        description: 'Assessing opportunities and risks.',
      },
      {
        title: 'Advisory',
        description: 'Strategic guidance and feasibility evaluation.',
      },
      {
        title: 'Development Support',
        description: 'Planning and coordination with design & construction teams.',
      },
      {
        title: 'Delivery',
        description: 'Final asset positioning and handover.',
      },
    ],
  },

  {
    slug: 'land-survey',
    title: 'Land Survey',
    shortDescription:
      'Accurate land surveying services to support planning, design, and legal compliance.',
    image: LandSurvey,
    gallery: [LS1, LS2],

    description:
      `We provide precise land surveying services using modern equipment and techniques. Our surveys support
      architectural design, engineering works, land registration, and construction planning while ensuring
      compliance with regulations.`,

    features: [
      'Topographic surveys',
      'Boundary & cadastral surveys',
      'Site analysis & mapping',
      'As-built surveys',
      'Construction setting-out',
    ],

    process: [
      {
        title: 'Site Assessment',
        description: 'Understanding terrain and project requirements.',
      },
      {
        title: 'Data Collection',
        description: 'Field measurements using modern surveying tools.',
      },
      {
        title: 'Analysis',
        description: 'Processing and validating survey data.',
      },
      {
        title: 'Reporting',
        description: 'Survey drawings and technical reports.',
      },
    ],
  },
]
